import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Details from './Details';
import Section from '../Section';
import { joinPath } from 'utils/path';
function ITSkills({ className, editPath, indexedMeta, itSkills }) {
  const location = useLocation();
  
  const itSkillsData = useMemo(() => (itSkills && itSkills.itSkills) || [], [itSkills]);
  const path = useMemo(() => {
    return editPath ? joinPath(editPath, 'it-skills') : '';
  }, [editPath]);

  const editPathState = useMemo(() => ({ background: location }), [location]);

  return (
    <Section className={className} editPath={path} editPathState={editPathState} title="title.itSkills">
      {/* Boolean conversion needed to avoid displaying "0" when length is 0 */}
      {!!itSkillsData.length && <Details indexedMeta={indexedMeta} itSkills={itSkillsData} />}
    </Section>
  );
}

ITSkills.propTypes = {
  className: PropTypes.string,
  editPath: PropTypes.string,
  indexedMeta: PropTypes.object.isRequired,
  itSkills: PropTypes.object.isRequired
};

export default ITSkills;
